import React from 'react';
import { Text, View } from 'react-native';
import { isPhone } from '@helpers';
import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import Header from '@components/settings/v2/common/SettingsHeader';
import i18n from 'i18n-js';
import {
  PADDING_HORIZONTAL_FOR_SHADOW,
  SCREEN_PADDING_HORIZONTAL,
} from '../../../../../v2/pages/common/constants/base.constants';
import RadioButtonsWithFetchCall from '@components/common/radioButtonsWithFetchCall';

import { useManageMachinesOperationDetails } from './hooks/useManageMachinesOperationDetails';

const MachinesOperationDetails = ({ C }: WithColor) => {
  const {
    operation,
    machines,
    selectedList,
    loaded,
    isOperationsProcessing,
    processingOperations,
    onSelectMachine,
    onSelectedListChange,
    onBackButtonPressed,
  } = useManageMachinesOperationDetails();

  return (
    <RadioButtonsWithFetchCall
      checkShouldDisplayLoadingForItem={(machine) => isOperationsProcessing && processingOperations.current.includes(machine.machineId)}
      shouldRunTimeout={!!operation}
      loaded={loaded}
      timeoutCallback={onSelectedListChange}
      timeoutDependencies={[selectedList.length]}
      items={machines}
      itemKeyExtractor={(machine) => `machine-${machine.machineId}`}
      isItemSelected={(machine) => selectedList.includes(machine.machineId)}
      onItemSelect={(machine) => onSelectMachine(machine.machineId)}
      getItemDisplayText={(machine) => machine.shortName}
      C={C}
    >
      <Header
        backBtnText={isPhone ? 'Back' : 'Machines'}
        name={'MachinesOperationDetails'}
        header={operation?.operationName ?? ' '}
        backButtonAction={onBackButtonPressed}
      />
      {loaded && (
        <View style={{ marginTop: scale(isPhone ? 0 : 13), paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL) - PADDING_HORIZONTAL_FOR_SHADOW }}>
          <Text
            style={[
              font[isPhone ? 'Footnote' : 'Headline'],
              { color: C(isPhone ? 'Label/Light/Tertiary' : 'Label/Light/Primary'), paddingHorizontal: PADDING_HORIZONTAL_FOR_SHADOW },
            ]}
          >
            {i18n.t('Select the Machines to include in this group')}
          </Text>
        </View>
      )}
    </RadioButtonsWithFetchCall>
  );
};

export default ColorWrapper(MachinesOperationDetails);
